const Mutations = Object.freeze({
	SET_LOADING: 'inventoryFormModule/formBuilder/filters/SET_LOADING',
	SET_FILTERS: 'inventoryFormModule/formBuilder/filters/SET_FILTERS',
	SET_ENTITIES: 'inventoryFormModule/formBuilder/filters/SET_ENTITIES',
	SET_FIELDS: 'inventoryFormModule/formBuilder/filters/SET_FIELDS',
	SET_SELECTED_FILTERS:
		'inventoryFormModule/formBuilder/filters/SET_SELECTED_FILTERS',
	SET_SELECTED_INVENTORY_FORM:
		'inventoryFormModule/formBuilder/filters/SET_SELECTED_INVENTORY_FORM',
});
export const Actions = Object.freeze({
	CLEAR_FIELDS:
		'inventoryFormModule/formBuilder/filters/CLEAR_ENTITIES_FIELDS',
	CLEAR: 'inventoryFormModule/formBuilder/filters/CLEAR',
	LOAD_FILTERS: 'inventoryFormModule/formBuilder/filters/LOAD_FILTERS',
	LOAD_FIELDS: 'inventoryFormModule/formBuilder/filters/LOAD_FIELDS',
	REMOVE_FILTERS: 'inventoryFormModule/formBuilder/filters/REMOVE_FILTERS',
	LOAD_ENTITIES: 'inventoryFormModule/formBuilder/filters/LOAD_ENTITIES',
	INSERT_FILTERS: 'inventoryFormModule/formBuilder/filters/INSERT_FILTERS',
	UPDATE_FILTERS: 'inventoryFormModule/formBuilder/filters/UPDATE_FILTERS',
});
export const Getters = Object.freeze({
	LOADING: 'inventoryFormModule/formBuilder/filters/LOADING',
	FILTERS: 'inventoryFormModule/formBuilder/filters/FILTERS',
	ENTITIES: 'inventoryFormModule/formBuilder/filters/ENTITIES',
	FIELDS: 'inventoryFormModule/formBuilder/filters/FIELDS',
});
import dataService from '../../../../../../services/data/inventoryFormService';
import { GeneralActions } from '../../../../../actions';

export default {
	state: {
		loading: false,
		selectedFilters: [],
		filters: [],
		entities: [],
		fields: [],
		selectedInventoryForm: null,
	},
	mutations: {
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_FILTERS](state, items) {
			state.filters = items;
		},
		[Mutations.SET_ENTITIES](state, items) {
			state.entities = items;
		},
		[Mutations.SET_FIELDS](state, items) {
			state.fields = items;
		},
		[Mutations.SET_SELECTED_FILTERS](state, items) {
			state.selectedFilters = items;
		},
		[Mutations.SET_SELECTED_INVENTORY_FORM](state, items) {
			state.selectedInventoryForm = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			commit(Mutations.SET_FILTERS, []);
			commit(Mutations.SET_ENTITIES, []);
			commit(Mutations.SET_FIELDS, []);
			commit(Mutations.SET_SELECTED_FILTERS, []);
			commit(Mutations.SET_SELECTED_INVENTORY_FORM, null);
		},
		[Actions.CLEAR_FIELDS]({ commit }) {
			commit(Mutations.SET_FIELDS, []);
		},
		[Actions.LOAD_FILTERS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				dispatch(GeneralActions.LOADING, true);
				Promise.all([
					dataService.getFilters(id).then((resp) => {
						commit(Mutations.SET_FILTERS, resp.data);
						commit(Mutations.SET_LOADING, false);
					}),
					dataService.getEntities().then((resp) => {
						commit(Mutations.SET_ENTITIES, resp.data);
					}),
					dataService.getById(id).then((resp) => {
						commit(
							Mutations.SET_SELECTED_INVENTORY_FORM,
							resp.data
						);
					}),
				])
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD_FIELDS]({ commit, dispatch }, entity) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getFormFieldsByEntityId(entity)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_FILTERS, entity);
						commit(Mutations.SET_FIELDS, resp.data);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.REMOVE_FILTERS](
			{ dispatch, state },
			{ inventoryFormId: inventoryFormId, gridViewId: gridViewId }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteFilters(inventoryFormId, gridViewId)
					.then(() => {
						let filtersEntity = [];
						Object.entries(state.filters).forEach((el) => {
							filtersEntity.push(el[1]);
						});
						let index = filtersEntity.findIndex(
							(x) =>
								x.InventoryFormId == inventoryFormId &&
								x.GridViewId == gridViewId
						);
						state.filters.splice(index, 1);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.INSERT_FILTERS]({ dispatch, commit, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertFilters(item)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_FILTERS, resp.data);
						state.filters.push(resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.UPDATE_FILTERS]({ dispatch, state, commit }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				item.Filters = item.Filters.filter((x) => !x.IsDeleted);
				dataService
					.updateFilters(item)
					.then(() => {
						let filters = JSON.parse(JSON.stringify(state.filters));
						dispatch(GeneralActions.LOADING, false);
						let index = filters.findIndex(
							(o) => o.GridViewId === item.GridViewId
						);
						filters[index] = item;
						filters[index].Count = filters[index].Filters.length;
						commit(Mutations.SET_FILTERS, filters);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {
		[Getters.FILTERS]: (state) => {
			return state.filters;
		},
		[Getters.ENTITIES]: (state) => {
			let filtersEntity = [];
			Object.entries(state.filters).forEach((el) => {
				filtersEntity.push(el[1].EntityId);
			});
			let difference = state.entities.filter(
				(x) => !filtersEntity.includes(x.Id)
			);
			return difference;
		},
		[Getters.FIELDS]: (state) => {
			if (!state.selectedFilters) return [];
			if (!state.selectedInventoryForm) return [];
			let fields = [];
			if (
				state.selectedFilters.EntityId ===
				state.selectedInventoryForm.Id
			) {
				state.selectedInventoryForm.FormFields.forEach((ff) => {
					ff.GridViewFields.forEach((gvf) => fields.push(gvf));
				});
			} else {
				fields = state.fields;
			}
			return JSON.parse(JSON.stringify(fields));
		},
	},
};
